import { CheckoutBody, SessionData, GosSubmitBody } from "./interfaces";

class ServiceCallsAPI {
  callCheckout(idempotencyKey: string, body: CheckoutBody) {
    return fetch(`/payments/checkout?idempotencyKey=${idempotencyKey}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }

  callCheckoutUpdate(
    idempotencyKey: string,
    body: CheckoutBody,
    paymentID: string,
  ) {
    return fetch(
      `/payments/checkout/${paymentID}?idempotencyKey=${idempotencyKey}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    );
  }

  callAssets(type: "in-honour" | "in-memory") {
    return fetch(`/presentation/assets?type=png&category=${type}`);
  }

  callGosSubmit(body: GosSubmitBody) {
    return fetch("/payments/gos-submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }

  callRecaptcha(body: { token: string; action: string }) {
    return fetch("/payments/captcha", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }

  callPresValue(presValue: string | null) {
    return fetch(`/presentation/${presValue}`);
  }

  callLookupId(lookupId: string, presValue: string) {
    return fetch(`/constituents/${lookupId}/${presValue}`);
  }

  callCid(cid: string) {
    // NOTE: This calls the service directly, because it is only available for ertain IPs
    return fetch(
      `${process.env.REACT_APP_CONSTITUENT_API_BASE_URL}/constituents/fd/${cid}`,
      {
        headers: {
          "X-API-KEY": process.env.REACT_APP_CONSTITUENT_API_KEY,
        },
      },
    );
  }

  callAttribution(email: string) {
    return fetch(
      `/constituents/attributions?email=${encodeURIComponent(email)}`,
    );
  }

  callSession(data: SessionData) {
    return fetch("/constituents/cart-abandon", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  }

  callGetAuthToken() {
    return fetch("/.auth/me");
  }

  callRefreshToken() {
    return fetch("/.auth/refresh");
  }
}

export default new ServiceCallsAPI();
